import { getHexToRgba } from "@nykaa/payment-ui/src/common/helpers/getHexToRgba";
import { Image } from "@nykaa/payment-ui/src/Image";
import { Text } from "@nykaa/payment-ui/src/Text";
import { ShimmerRow } from "components/ShimmerRow/shimmer";
import { NEW_ADDRESS_DEFAULT_MESSAGE } from "constants/address";
import { useTheme } from "emotion-theming";
import { getIcons, ICONS_NAMES } from "helpers/utils/getIcons";
import React, { useEffect, useState } from "react";
import { DetectedCityConfig } from "./@types";
import { AutoDetectButton, DetectedCityLayout, LocationLayout } from "./assets/style";


const DetectedCity = ({
  detectingCity,
  detectedCity,
  detectedState,
  locationSecondaryText,
  pinCode,
  platform,
  errorState,
  getCurrentGeoLocation,
  isAutoDetectLocationEnabled,
  fetchingGeoLocation,
  errorFetchingGeoLocation,
}: DetectedCityConfig) => {
  const theme: Theme = useTheme();
  const [showDefaultState, setShowDefaultState] = useState(false);
  const defaultLocationBackgroudColor = "#F8F8F8";
  let detectedLocationBackgroudColor = theme?.colors?.lightCityBackground;
  const detectedLocationBackgroudURL = getIcons(platform, ICONS_NAMES.MAPS_BACKGROUND);
  const defaultStateBackgroudURL = getIcons(platform, ICONS_NAMES.STREET_VIEW);
  let locationHeading = showDefaultState ? NEW_ADDRESS_DEFAULT_MESSAGE.ENTER_PINCODE : `${detectedCity}${detectedState ? `, ${detectedState}` : ""}`;
  let locationSubHeading = showDefaultState ? NEW_ADDRESS_DEFAULT_MESSAGE.WE_DETECT_LOCATION : locationSecondaryText;

  if (errorFetchingGeoLocation) {
    locationHeading = "Unable to detect location";
    locationSubHeading = "Add address manually";
    detectedLocationBackgroudColor = "#FBFBFB";
  }
  useEffect(() => {
    if (!pinCode || errorState) {
      setShowDefaultState(true);
    } else {
      setShowDefaultState(false);
    }
  }, [pinCode, errorState]);

  if (isAutoDetectLocationEnabled) {
    return (
      <DetectedCityLayout backgroudColor={showDefaultState && !errorFetchingGeoLocation ? defaultLocationBackgroudColor : detectedLocationBackgroudColor}>
        {((!detectedCity || detectingCity) && !showDefaultState) || fetchingGeoLocation ? <ShimmerRow width="100%" height="72px" /> : (
          <LocationLayout errorFetchingGeoLocation={errorFetchingGeoLocation} backgroudURL={showDefaultState && !errorFetchingGeoLocation ? defaultStateBackgroudURL : detectedLocationBackgroudURL}>
            {
              showDefaultState && !errorFetchingGeoLocation ? (
                <>
                  <AutoDetectButton
                    className="layout horizontal center-center auto-detect-btn"
                    type="button"
                    onClick={getCurrentGeoLocation}
                  >
                    <div className="locate-icon">
                      <Image
                        url={getIcons(platform, ICONS_NAMES.DETECT_LOCATION)}
                        alt={"Auto Detect"}
                        theme={theme}
                      />
                    </div>
                    <div className="layout vertical">
                      <div className="layout horizontal">
                        <Text
                          text={NEW_ADDRESS_DEFAULT_MESSAGE.USE_CURRENT_LOCATION}
                          font={theme.typography.buttonLarge}
                          theme={theme}
                          color={theme.brandPrimary}
                        />
                        <Image
                          url={getIcons(platform, ICONS_NAMES.PRIMARY_RIGHT_ARROW)}
                          alt={"Right Arrow"}
                          theme={theme}
                        />
                      </div>
                      <Text
                        text={NEW_ADDRESS_DEFAULT_MESSAGE.ACCURATE_DELIVERY}
                        font={theme.typography.bodySmall}
                        theme={theme}
                        color={theme?.colors?.textPrimary064}
                      />
                    </div>
                  </AutoDetectButton>
                </>
              ) : (
                <>
                  <Text
                    text={locationHeading}
                    font={theme.typography.subTitleLarge}
                    theme={theme}
                    color={getHexToRgba(theme.colors.textPrimary, 0.92)}
                  />
                  <Text
                    text={locationSubHeading}
                    font={theme.typography.bodySmall}
                    theme={theme}
                    color={theme?.colors?.textPrimary064}
                  />
                </>
              )
            }
          </LocationLayout>
        )}
      </DetectedCityLayout>
    );
  } else {
    return (
      <DetectedCityLayout backgroudColor={showDefaultState ? defaultLocationBackgroudColor : detectedLocationBackgroudColor}>
        {(!detectedCity || detectingCity) && !showDefaultState ? <ShimmerRow width="100%" height="72px" /> : (
          <LocationLayout backgroudURL={showDefaultState ? defaultStateBackgroudURL : detectedLocationBackgroudURL}>
            <Text
                text={locationHeading}
                font={theme.typography.subTitleLarge}
                theme={theme}
                color={getHexToRgba(theme.colors.textPrimary, 0.92)}
              />
            <Text
                text={locationSubHeading}
                font={theme.typography.bodySmall}
                theme={theme}
                color={theme?.colors?.textPrimary064}
              />
          </LocationLayout>
        )}
      </DetectedCityLayout>
    );
  }
};

export default DetectedCity;
